import {  
    CORE_GET_CATEGORY_INFO_REQUEST,
    CORE_GET_CATEGORY_INFO_SUCCESS
  
  } from '../../types'
  
  const initialState = []
  export default {
    fbCategoryInfo: (state = initialState, action) => {
        switch (action.type) {
          case CORE_GET_CATEGORY_INFO_REQUEST:
            return {}
    
          case CORE_GET_CATEGORY_INFO_SUCCESS:
            return action.payload
    
          default:
            return state
        }
    },
  }


// WEBPACK FOOTER //
// ./src/features/fbCategory/reducer.js